module.exports = __webpack_public_path__ + "static/img/img3.9a80076f.png";